var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.963 31.0012C14.8378 31.0012 12.0324 29.8273 10.076 27.9656L12.6476 25.8905C13.9642 27.1474 15.859 27.93 17.963 27.93C21.9496 27.93 25.1733 25.1079 25.1733 21.6217C25.1733 18.266 22.1834 15.5269 18.4183 15.3253L18.3199 17.353L13.878 14.0684L18.7136 9.5625L18.5782 12.266C24.2013 12.5506 28.6677 16.6297 28.6677 21.6217C28.6677 26.8154 23.869 31.0012 17.963 31.0012ZM7.71364 24.3372L7 23.4715L7.98434 22.8431L8.55033 23.8036L7.71364 24.3372ZM9.43623 25.1198L10.2606 24.5269L9.59618 23.6257L8.66107 24.3134L9.43623 25.1198ZM10.9866 25.8668L11.7863 25.2028L11.0358 24.3609L10.1499 25.096L10.9866 25.8668ZM8.63646 26.4478L7.86129 25.6296L8.79641 24.9419L9.44853 25.8549L8.63646 26.4478ZM10.0637 27.6929L10.8635 27.0288L10.1745 26.1277L9.27628 26.851L10.0637 27.6929Z",
    fill: "url(#paint0_linear_320_70740)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0367 5C21.1619 5 23.9673 6.17391 25.9237 8.03556L23.3521 10.1107C21.9289 8.78024 20.0194 8.04331 18.0367 8.05928C14.0501 8.05928 10.8264 10.8814 10.8264 14.3676C10.8264 17.7233 13.8163 20.4624 17.5814 20.664L17.6799 18.6363L22.1217 21.9209L17.2861 26.4268L17.4215 23.7233C11.7985 23.4387 7.33203 19.3596 7.33203 14.3676C7.33203 9.19761 12.1184 5 18.0367 5ZM28.2861 11.6759L28.9997 12.5415C28.6675 12.7549 28.3476 12.9565 28.0154 13.1699C27.8185 12.8616 27.6216 12.5415 27.4248 12.2332C27.7078 12.0435 28.0031 11.8656 28.2861 11.6759ZM26.5635 10.8933L25.7637 11.4743L26.4158 12.3873L27.351 11.6996L26.5635 10.8933ZM25.0009 10.1225L24.2257 10.7628L24.9516 11.6522L25.8375 10.917L25.0009 10.1225ZM27.3633 9.5652L28.1384 10.3834L27.2033 11.0711L26.5512 10.1581L27.3633 9.5652ZM25.8868 8.36758L25.1116 8.99603L25.8129 9.8735L26.7111 9.15018L25.8868 8.36758Z",
    fill: "url(#paint1_linear_320_70740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_320_70740",
    x1: 19.9009,
    y1: 28.4399,
    x2: 15.3517,
    y2: 13.7148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64BD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#61BD58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#35C48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_320_70740",
    x1: 15.9838,
    y1: 7.93477,
    x2: 21.3967,
    y2: 23.7654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3976B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3F88C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4190C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#48A4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1BBDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CCCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a33036113d098b8ec25ac08cf2dd866d.svg";
export { ForwardRef as ReactComponent };